import { apiClient } from '~/adapters/apiClient';
import log from '~/logger';
export async function fetchProductImages(productIds) {
    if (productIds.length === 0) {
        return [];
    }
    const url = '/product_planning/product_images/v1';
    const requestBody = {
        productIds: productIds.map(String)
    };
    try {
        const data = await apiClient.post(url, 'pulse-bff', requestBody);
        return data.objects;
    }
    catch (error) {
        log.error('Failed to fetch product images', {
            error: error instanceof Error ? error.message : 'Unknown error',
            productIds
        });
        return [];
    }
}
export async function fetchProductImage(productId) {
    try {
        const results = await fetchProductImages([productId]);
        return results[0] || null;
    }
    catch (error) {
        log.error('Failed to fetch product image', {
            error: error instanceof Error ? error.message : 'Unknown error',
            productId
        });
        return null;
    }
}
